module.exports = __webpack_public_path__ + "static/media/tv.36609817.png";